export default class ChartDataService {

  constructor(trials) {
    this.trials = trials;
  }

  getChart(trial, id) {
    if (this.trials[trial] && this.trials[trial][id]) {
      return { ...this.trials[trial][id] }
    }
  }

  getDataSummary() {
    // returns a simple representation of the overall data sets
    const summary = Object.keys(this.trials).map(trial => {
      return {
        trial,
        sets: Object.keys(this.trials[trial]).map(set => {
          return {
            id: set,
            type: this.trials[trial][set]['config']['type']
          }
        }).filter(set => set.type !== 'image' && set.type !== 'table')
      }
    })
    return summary
  }

  __temp__getMedianForTrial(trial, id) {
    if (id === 'driving-sdlp-indiv') {
      return [
        { x: 1, y: -1.1 },
        { x: 2, y: -0.8 },
      ];
    }

    return [];
  }

  /*
   * `outerWidth` and `outerHeight` were added because, if you don't specify the `width` and `height`
   * attributes of a SVG element, it will have a minimum height of 150 pixels:
   * https://www.google.com/search?q=svg+300+150&rlz=1C5CHFA_enCA876CA877&oq=svg+300+1&aqs=chrome.0.0j69i57.2874j0j7&sourceid=chrome&ie=UTF-8
   */

  // The first parameter is the config. We'll require it later
  getOuterWidth(_, activeCard, chartExpanded) {
    const isMiniature = !chartExpanded && (activeCard?.content?.length > 1);
    if (isMiniature) {
      return 357;
    }
  }

  getOuterHeight(config, activeCard, chartExpanded) {
    const isMiniature = !chartExpanded && (activeCard?.content?.length > 1);
    if (isMiniature) {
      let height = 80;

      switch (config?.id) {
        case "tones-3-wpai-abs":
        case "tones-3-wpai-pres":
        case "tones-3-wpai-workimp":
        case "tones-3-wpai-actimp":
          height = 40;
          break;
      }

      return height;
    }
  }

  _getDefaultMargin(config) {
    if (config?.type == 'line') {
      // line chart default
      return { top: 40, right: 10, bottom: 5, left: 75 }
    } else if (config?.type == 'dotplot') {
      // dotplot chart default
      return { top: 40, right: 30, bottom: 15, left: 70 }
    }
    // bar chart default
    return { top: 40, right: 10, bottom: 5, left: 75 };
  }

  getMargin(config, breakpoint) {
    const margin = this._getDefaultMargin(config);
    const isIPadPro = breakpoint === 'iPadPro';

    if (config?.trial === "tones-3") {
      const left = isIPadPro ? 120 : 78;
      switch (config.id) {
        case "24h-dbp":
        case "24h-sbp":
          margin.bottom = 18;
          if (isIPadPro) {
            margin.left = left;
          }
          break;
        case "ess-mitt":
          margin.left = left;
          break;
        case "mwt-indiv":
          margin.bottom = 20;
          margin.left = left;
          break;
        case "mwt-mitt":
          margin.left = left;
          break;
        case "pgic":
        case "cgic":
          margin.top = 20;
          margin.bottom = 0;
          margin.left = 85;
          break;
        case 'ae-incidence-anxiety':
        case 'ae-incidence-appetite':
        case 'ae-incidence-headache':
        case 'ae-incidence-insomnia':
        case 'ae-incidence-jittery':
        case 'ae-incidence-nausea':
          margin.left = 65;
          break;
      }
    } else if (config?.trial === "tones-5") {
      switch (config.id) {
        case "tones-5-ess-groupa":
        case "tones-5-ess-groupb":
          margin.bottom = 20;
          break;
        case "ess-mitt-rwp":
          margin.left = 100;
          break;
      }
    } else if (config?.trial === "narcolepsy") {
      switch (config.id) {
        case "cataplexy-dbrwp":
          margin.bottom = 40;
          margin.left = 85;
          break;
        case "ess":
          margin.bottom = 40;
          break;
        case "cataplexyattacks-olottp-sdp":
          margin.left = 88;
          break;
        case "cataplexyfree-olottp-sdp":
          margin.left = isIPadPro ? 100 : 90;
          break;
      }
    }

    return margin;
  }
}
